import React, { useEffect } from 'react';
import { AccessPoints } from '../components/Home/AccessPoints';
import { FinalCTA } from '../components/Home/FinalCTA';
export const JoinNow = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20 bg-white" data-id="element-3569" data-mp="1gc6bcuoiukau">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-200" data-id="element-3570" data-mp="1galiralrpbfm">
        <div className="absolute inset-0 z-0" data-id="element-3571" data-mp="1ub5z8047mv5y">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3572" data-mp="1u9uuny2xxjds" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3573" data-mp="2417lqngx05ir"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3574" data-mp="1z3z2sknxzxgg">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3575" data-mp="2d1xhjr66dvwh">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3576" data-mp="2d0cmm0fy8ay3">
              Join The Networking Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3577" data-mp="2e3u300um5cxs">
              Choose your pathway into our community based on your goals and
              commitment level
            </p>
          </div>
        </div>
      </section>
      {/* Access Points Section */}
      <AccessPoints data-id="element-3578" data-mp="2n63h10p3bofx" />
      {/* Explanation Section */}
      <section className="py-16 bg-white border-t border-gray-200" data-id="element-3579" data-mp="2s44wlbnb55mn">
        <div className="container mx-auto px-4" data-id="element-3580" data-mp="2x2g6fmdlrg4v">
          <div className="max-w-3xl mx-auto" data-id="element-3581" data-mp="2x1omj8tdb6uf">
            <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-3582" data-mp="313jn2b3h5g75">
              Choose Your Community Experience
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-3583" data-mp="35vt6d8a33i0g">
              The Networking Salon offers multiple ways to engage with our
              community, each designed to meet you where you are on your
              professional journey.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-3584" data-mp="3krse2hta7g52">
              Whether you're looking for a free entry point to explore what we
              offer, seeking the full benefits of our curated community, or
              ready for personalized strategic guidance - we have a pathway
              that's right for you.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-3585" data-mp="34tolg8rrfc4m">
              Select the option above that best aligns with your goals and level
              of commitment. Each pathway offers a unique set of benefits and
              opportunities to connect, grow, and thrive within our ecosystem.
            </p>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gray-50" data-id="element-3586" data-mp="3nsanpqz0j9a4">
        <div className="container mx-auto px-4 text-center" data-id="element-3587" data-mp="3nqzlhvl7u9l4">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-3588" data-mp="3itha7yjq7i9y">
            Join Today and Transform How You Connect
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-3589" data-mp="1tejid3npvbkh">
            Stop collecting business cards. Start building relationships that
            change your future.
          </p>
        </div>
      </section>
    </div>;
};